import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../../app/SliceUtils";

export const getLocations = createAsyncThunk(
    '/api/locationManagement',
    (_, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/locationManagement`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const postLocation = createAsyncThunk(
    '/api/locationManagement/post',
    (newLocation, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/locationManagement`,
            method: 'POST',
            body: newLocation
        }, rejectWithValue)
);

export const putLocation = createAsyncThunk(
    '/api/locationManagement/put',
    (updatedLocation, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/locationManagement`,
            method: 'PUT',
            body: updatedLocation
        }, rejectWithValue)
);

export const deleteLocation = createAsyncThunk(
    '/api/locationManagement/delete',
    (locationId, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/locationManagement/${locationId}`,
            method: 'DELETE'
        }, rejectWithValue)
);

export const locationManagementSlice = createSlice({
    name: 'locationManagement',
    initialState: {
        locations: { data: null, status: null },
        locationPost: { data: null, status: null },
        locationPut: { data: null, status: null },
        locationDelete: { data: null, status: null },

        selectedLocation: null,
        showFailed: false,
    },
    reducers: {
        selectLocation: (state, action) => {
            state.selectedLocation = action.payload;
        },
        setFailedLocation: (state, action) => {
            state.showFailed = action.payload;
        },
        resetLocationStatus: (state) => {
            ResetSliceState(state);
        },
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, getLocations, 'locations');
        CreateAsyncStatusHandler(builder, postLocation, 'locationPost');
        CreateAsyncStatusHandler(builder, putLocation, 'locationPut');
        CreateAsyncStatusHandler(builder, deleteLocation, 'locationDelete');
    },
});

export const {
    resetLocationStatus,
    selectLocation,
    setFailedLocation
} = locationManagementSlice.actions;

export default locationManagementSlice.reducer;
